import { render, staticRenderFns } from "./IndexMandarin.vue?vue&type=template&id=44191800&"
import script from "./IndexMandarin.vue?vue&type=script&lang=js&"
export * from "./IndexMandarin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports